class WCDayNight extends HTMLElement {
  constructor() {
    super();

    this.SELECTOR_NAV_ITEM = '.wc-day-night-nav';
    this.SELECTOR_FRAME = '.wc-frame';
    this.CLASS_ACTIVE = 'active';
    this.ELM_navItems = this.querySelectorAll(this.SELECTOR_NAV_ITEM);

    this.ELM_navItems.forEach(ELM_navItem => ELM_navItem.addEventListener('click', () => {
      const ELM_currentActiveFrame = this.querySelector(`${this.SELECTOR_FRAME}.${this.CLASS_ACTIVE}`);
      const ELM_currentActiveNav = this.querySelector(`${this.SELECTOR_NAV_ITEM}.${this.CLASS_ACTIVE}`);
      ELM_currentActiveFrame?.classList.remove(this.CLASS_ACTIVE);
      ELM_currentActiveNav?.classList.remove(this.CLASS_ACTIVE);

      const type = ELM_navItem.dataset.type;
      const ELM_activeFrame = this.querySelector(`${this.SELECTOR_FRAME}[data-type="${type}"]`);
      ELM_navItem.classList.add(this.CLASS_ACTIVE);
      ELM_activeFrame.classList.add(this.CLASS_ACTIVE);
    }))

    if (this.dataset.interval) {
      setInterval(() => {
        const ELM_currentActiveFrame = this.querySelector(`${this.SELECTOR_FRAME}.${this.CLASS_ACTIVE}`);
        ELM_currentActiveFrame.classList.remove(this.CLASS_ACTIVE);
        const currentIndex = Number(ELM_currentActiveFrame.dataset.index);
        const nextIndex = (currentIndex + 1) % Number(this.dataset.count);

        const ELM_currentActiveNav = this.querySelector(`${this.SELECTOR_NAV_ITEM}[data-index="${currentIndex}"]`);
        ELM_currentActiveNav?.classList.remove(this.CLASS_ACTIVE);
  
        const ELM_activeFrame = this.querySelector(`${this.SELECTOR_FRAME}[data-index="${nextIndex}"]`);
        const ELM_activeNav = this.querySelector(`${this.SELECTOR_NAV_ITEM}[data-index="${nextIndex}"]`);
        ELM_activeFrame.classList.add(this.CLASS_ACTIVE);
        ELM_activeNav.classList.add(this.CLASS_ACTIVE);
      }, Number(this.dataset.interval) * 1000);
    }
  }
}
customElements.define('wc-day-night', WCDayNight);